export { default } from './MainImage';
